import { useMemo, useState } from 'react';

import { useAppSelector } from 'features/app/hooks';
import { useHearings } from 'features/call/call-hearing/hooks';
import {
  selectLastSecondaryHearing,
  primaryHearingSelector,
} from 'features/call/call-hearing/store';

export const useDialPadParticipant = () => {
  const { activeHearings } = useHearings();
  const [manuallySelectedParticipantId, setManuallySelectedParticipantId] =
    useState<string | null>();
  const lastConnectedHearing = useAppSelector(selectLastSecondaryHearing);
  const primaryHearing = useAppSelector(primaryHearingSelector);

  const selectedValue = useMemo(() => {
    if (
      manuallySelectedParticipantId &&
      activeHearings.some((o) => o.id === manuallySelectedParticipantId)
    ) {
      return manuallySelectedParticipantId;
    }

    if (lastConnectedHearing?.status === 'connected') {
      return lastConnectedHearing.id;
    }

    if (primaryHearing.status === 'connected') {
      return primaryHearing.id;
    }

    return null;
  }, [
    activeHearings,
    lastConnectedHearing,
    primaryHearing,
    manuallySelectedParticipantId,
  ]);

  return {
    participantId: selectedValue,
    setParticipantId: setManuallySelectedParticipantId,
  };
};
